var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsAppSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 65.2852C50.4493 65.2852 65 50.7344 65 32.7852C65 14.8359 50.4493 0.285156 32.5 0.285156C14.5507 0.285156 0 14.8359 0 32.7852C0 50.7344 14.5507 65.2852 32.5 65.2852Z",
    fill: "#FCF5EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 64.7852C50.1731 64.7852 64.5 50.4583 64.5 32.7852C64.5 15.112 50.1731 0.785156 32.5 0.785156C14.8269 0.785156 0.5 15.112 0.5 32.7852C0.5 50.4583 14.8269 64.7852 32.5 64.7852Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4171 45.3394C27.028 45.7631 26.4965 46.0286 25.9241 46.0853C25.346 46.0187 24.8106 45.7482 24.4141 45.3223L14.9141 35.8223L17.9341 32.8024L25.9411 40.8093L47.1171 19.4854L50.0861 22.5564L27.4171 45.3394Z",
    fill: "#25D366"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppSuccess);
export default __webpack_public_path__ + "static/media/whatsAppSuccess.90625bc962ce0c4a90ec16786a97de6d.svg";
export { ForwardRef as ReactComponent };